import React, { useEffect, useState } from 'react'
import { connect } from "react-redux"
import TopBarNav from '../common/TopBarNav'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import Icon from 'antd/es/icon'
import { useHistory, Link as RouterLink } from 'react-router-dom'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import * as navigationActions from '../../actions/common/NavigationActions'
import { TelematicsStyles } from './TelematicsStyles'
import * as telematicsActions from '../../actions/telematics/TelematicsActions'
import { bindActionCreators } from 'redux'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const TelematicsTechnicianDashboard = ({ classes, ...props }) => {
    const history = useHistory()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t } = useTranslation()

    useEffect(() => {
        handleOpenBackdrop()
        props.navigationActions.clean_routes()
        const newRoute = {
            path: '/telematics/InstallationOrders/My',
            linkLegend: t('telematicsInstallers.myInstallationOrders'),
            urlParams: [{ key: 'branchOfficeId', value: '' }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Technicians_Orders(props.userLanguage, props.userToken, onError, onSuccess)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    alert(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory /> 
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                        <br />
                        <h5>{t('telematicsInstallers.myInstallationOrders')}</h5>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid container item xs={12} spacing={3}>
                        {
                            props.technicianOrdersList.map((itemDashboard, index) => {
                                return (
                                    <Grid item xs={4} key={index}>
                                        <Card className={classes.borderRadius}>
                                            <CardActionArea component={RouterLink} to={`/telematics/listByStatus/EnProceso&${itemDashboard.branchOfficeId}`}>
                                                <CardHeader className={classes.cardHeader}
                                                    title={`${itemDashboard.serviceDescription}`}
                                                    titleTypographyProps={{ variant: 'h6' }}
                                                />
                                                <CardContent className={classes.dashboardAlign}>
                                                    {<Icon type="book" className={classes.dashboardIcon} theme="outlined" /> }
                                                    <br />
                                                    <br />
                                                    <Grid container item xs={12} className={classes.dashboardAlign}>
                                                        <br />
                                                        <Grid item xs={12} >
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography>Total</Typography>
                                                            </Grid>
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography>{itemDashboard.numberOfOrders}</Typography>
                                                                <br />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                );
                            }
                            )
                        }
                        </Grid>
                    <Grid item xs={12}><br /></Grid>
                </Grid>
                {
                    props.technicianOrdersList.length <= 0 &&
                    <Typography className={classes.dashboardAlign}>{t('commonMessages.noData')}</Typography>
                }
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    technicianOrdersList: state.TelematicsReducer.technicianOrdersList,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(telematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(TelematicsTechnicianDashboard))
